module.exports = __webpack_public_path__ + "src/components/ViewMessage/GuestHostDetails/chat.png?c89773c7";


//////////////////
// WEBPACK FOOTER
// ./src/components/ViewMessage/GuestHostDetails/chat.png
// module id = 3381
// module chunks = 8